import React, { useEffect } from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import './style.scss';
import { useLocation } from "react-router-dom";

const seoByRoute = {
    "ludo-superstar-home": {
        title: "Ludo SuperStar - Play Online Ludo Game",
        description: "Stay updated with the latest Ludo Superstar updates, including new game modes, live events, rewards, and bug fixes. Play the best online Ludo game with friends, enjoy real-time multiplayer, and download the latest free Ludo app today."
    },
    "ludo-events": {
        "title": "Ludo Events – Live & Upcoming Multiplayer Events | Ludo Superstar",
        "description": "Explore live Ludo events and upcoming challenges in Ludo Superstar. Play online Ludo game with friends, join multiplayer events, win rewards, and enjoy the best free Ludo game experience."
    },
    "ludo-tips-and-tricks": {
        "title": "Ludo Tips & Tricks – Beginner to Pro Strategy Guide",
        "description": "Learn Ludo tips and tricks, rules, and winning strategies to improve your gameplay. Master the online Ludo game, play smarter, and win more multiplayer matches with expert guidance."
    },
    "top-ludo-players": {
        "title": "Top Ludo Players in the World – Leaderboard & Rankings",
        "description": "Discover top Ludo players, global rankings, and leaderboards in the best online Ludo game. Compete with friends and real players, climb ranks, and become a Ludo champion."
    },
    "ludo-updates": {
        "title": "Stay Updated: Latest App Versions and Updates for Ludo SuperStar",
        "description": "Get the latest Ludo Superstar updates, new features, game modes, and improvements. Download the free Ludo game, play online with friends, and enjoy the newest multiplayer experience."
    },
    "about-ludo-superstar": {
        title: "About Ludo Superstar – Online Multiplayer Ludo Game",
        description: "Ludo Superstar is a leading online multiplayer board game for Android and iOS. Play with friends, compete in live events, and join millions of players worldwide."
    },
    "contact-ludo-superstar": {
        title: "Contact Ludo Superstar – Support & Business Inquiries",
        description: "Contact Ludo Superstar for customer support, game assistance, or business partnerships. Email cc@bswgames.com or visit BlackLight Studio Games."
    },
    "blacklight-studio-games": {
        title: "BlackLight Studio Games – Casual Mobile Game Publisher",
        description: "BlackLight Studio Games develops and publishes casual mobile games including Ludo Superstar, Carrom Superstar, and Callbreak Multiplayer. Connect with us at blacklightsw.com."
    },
    "terms-of-service": {
        title: "Terms of Service – Ludo Superstar | BlackLight Studio Works",
        description: "Terms of Service for Ludo Superstar and other BlackLight Studio Works mobile games and applications. Read our terms, conditions, and policies."
    },
    "privacy-policy": {
        title: "Privacy Policy – Ludo Superstar | BlackLight Studio Works",
        description: "Privacy Policy for Ludo Superstar and other BlackLight Studio Works games. Learn how we collect, use, and protect your personal information."
    },
    "ludo-help-center": {
        title: "Ludo Superstar Support – Help Center & FAQ",
        description: "Get help with Ludo Superstar. Search our FAQ for events, game modes, login, in-game currencies, VIP, friends, chests, spectator mode, and gameplay."
    }
};

const Dashboard = (props) => {

    const location = useLocation();
    // Get current route segment (works with or without basename in pathname)
    const pathname = location.pathname.replace(/^\/+|\/+$/g, "");
    const segments = pathname.split("/").filter(seg => seg && seg !== "bsw-game");
    const url = segments[0] || "ludo-superstar-home";

    useEffect(() => {
        const seo = seoByRoute[url];
        if (!seo) return;

        document.title = seo.title;
        const descriptionMeta = document.querySelector('meta[name="description"]');
        if (descriptionMeta) {
            descriptionMeta.setAttribute("content", seo.description);
        }
    }, [url]);

    return (
        <div className="">
            <Header />
            < Footer />

        </div>
    );
}

export default Dashboard;